import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { Banner } from '../_shared/Banner/Banner';

type Props = {
    tld: string;
};

const DanaRibbon = ({ tld }: Props) => {
    if (tld != '.es') {
        return null;
    }

    const text = gettext(
        'Apoya a los damnificados por la DANA en Valencia. Colabora ahora donando a ',
    );
    const ctaLink = `https://cercadeti.cruzroja.es/eventbritedana`;
    const ribbonCtaText = gettext('Cruz Roja.');

    return (
        <Banner textAlign="center">
            <span className="eds-text-bm" style={{ fontWeight: 'bold' }}>
                {text}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={ctaLink || ''}
                >
                    <span className="eds-text-bm">{ribbonCtaText}</span>
                </a>
            </span>
        </Banner>
    );
};

export default DanaRibbon;
